// removed by extract-text-webpack-plugin
module.exports = {"tabGroup":"cover-gallery---tabGroup---24nh7","tabGroupLi":"cover-gallery---tabGroupLi---379n1","categoryTabItem":"cover-gallery---categoryTabItem---1UUPO","categoryTabItemSelected":"cover-gallery---categoryTabItemSelected---2izEN"};;
    if (module.hot) {
      var injectCss = function injectCss(prev, href) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = href;
        link.onload = function() {
          document.head.removeChild(prev);
        };
        document.head.appendChild(link);
      };
      module.hot.dispose(function() {
        window.__webpack_reload_css__ = true;
      });
      if (window.__webpack_reload_css__) {
        module.hot.__webpack_reload_css__ = false;
        console.log("[HMR] Reloading stylesheets...");
        var prefix = document.location.protocol + '//' + document.location.host;
        document
          .querySelectorAll("link[href][rel=stylesheet]")
          .forEach(function(link) {
            if (!link.href.match(prefix)) return;
            injectCss(link, link.href.split("?")[0] + "?unix=1789047462399");
          });
      }
    }
  